<template>
  <div class="text-right">
    <div class="head">
      <img :src="listData.icon" alt="" />
      <div class="txt">
        <div class="name">
          {{ listData.nickname }}
        </div>
        <div class="id">
          <span>ID</span> <span class="ids">{{ listData.userId }}</span>
        </div>
      </div>
    </div>

    <div class="pocket">
      <div class="pocket-txt">{{ $t("withdrawalLogin.pocket") }}</div>
      <div class="species">
        <img
          src="../../assets/h5/95a1eb22-e449-4d6a-9643-dd86329ef1b5.png"
          alt=""
        />
        <div>{{ listData.cin }}</div>
      </div>
    </div>

    <div class="list" v-for="item in listData.item" :key="item.id">
      <div v-if="item.name == 'papara' || item.name == 'binance'">
        <div class="list-txt" style="margin-top: 0.4rem;">{{ item.name }}</div>
        <div style="display:flex;flex-wrap: wrap;">
          <div
            class="list-box"
            v-for="Aitem in item.list"
            :key="Aitem.id"
            @click="channelBtn(item, Aitem)"
          >
            <div class="money">{{ Aitem.cc }} {{ Aitem.num }}</div>
            <div class="money-box">
              <img
                class="money-img"
                src="../../assets/h5/95a1eb22-e449-4d6a-9643-dd86329ef1b5.png"
                alt=""
              />
              <div class="money-num">{{ Aitem.usd }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-popup
      v-model:show="show"
      closeable
      round
      position="bottom"
      :style="{ height: '20%' }"
      class="popup"
      >{{ $t("withdrawalLogin.Pocket") }}</van-popup
    >
  </div>
</template>
<script>
import axios from "axios";
import { Toast,Popup } from "vant";
export default {
  name: "picWithdrawal",
  components: {
    VanPopup: Popup
  },
  data() {
    return {
      listData: {},
      token: "",
      uid: "",
      show: false,
      deviceId: '',
    };
  },
  created() {
    let data = JSON.parse(localStorage.getItem("data"));
    this.token = data.token;
    this.uid = data.uid;
    this.deviceId = data.deviceId;
    this.contact();
  },
  mounted() {
    this.$i18n.locale = localStorage.getItem("isLang")
    document.querySelector("html").setAttribute("lang", this.$i18n.locale);
  },

  methods: {
    contact() {
      axios
        .get(this.$serviceIp +`/api/trade/card/tx/getInfoForWeb?token=${this.token}&uid=${this.uid}`,{
            headers: {
                'deviceId': this.deviceId
              }
        })
        .then((response) => {
          if (response.data.code == 200) {
            this.listData = response.data.data;
          } else {
            Toast(response.data.message || this.$t("transfer.error"));
          }
        });
    },

    channelBtn(item, Aitem) {
      if (this.listData.cin < Aitem.usd) {
        this.show = true;
        return;
      }
      axios
        .get(
          this.$serviceIp +
            `/api/trade/card/tx/initForWeb?token=${this.token}&uid=${this.uid}&id=${item.id}`,{
              headers: {
                'deviceId': this.deviceId
              }
            }
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.$router.push({
              path: "/picDetails",
              query: {
                obj: JSON.stringify(response.data.data.infos),
                newobj: JSON.stringify(Aitem),
              },
            });
          } else {
            Toast(response.data.message || this.$t("transfer.error"));
          }
        });
    },
  },
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}


html[lang="ar"] .text-right{
  direction: rtl;
}
html[lang="ar"] .txt {
  margin-right: 0.3rem;
}
html[lang="ar"] .species img {
  margin-left: 0.1rem;
}

.returns {
  width: 0.8rem;
  height: 0.8rem;
  position: absolute;
}


.text-right {
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  padding: 0 15px;
}
.head {
  height: 0.95rem;
  /* width: 5.9rem; */
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
}

.head img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin: 0 10px;
}
.txt {
  width: 2rem;
  height: 0.7rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.name {
  font-size: 0.27rem;
  font-family: Rubik;
  font-weight: 400;
  color: #000000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.id {
  font-size: 0.24rem;
  font-family: Rubik;
  font-weight: 400;
  color: #acadbc;
}
.pocket {
  /* width: 5.9rem; */
  height: 1rem;
  background: linear-gradient(180deg, #ffffff -6.39%, #fff2d0 100%);
  border-radius: 12px;
  margin-top: 0.34rem;
  padding: 0 0.34rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
}

.pocket-txt {
  /* width: 1.5rem; */
  height: 0.34rem;
  font-size: 0.24rem;
  color: rgba(0, 0, 0, 0.5);
  font-family: PingFang SC;
}
.species {
  /* width: 1.24rem; */
  height: 0.44rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.species img {
  width: 0.41rem;
  height: 0.41rem;
  margin-right: 0.1rem;
}

.species div {
  /* width: 0.73rem; */
  height: 0.45rem;
  font-size: 0.37rem;
  color: rgba(128, 62, 57, 1);
  font-family: Rubik;
}

.list {
  /* width: 5.8rem; */
  /* height: 1.9rem; */
  /* margin-top: 0.4rem; */
}

.list-box {
  width: 1.77rem;
  height: 1.5rem;
  margin-top: 0.3rem;
  margin-left: 0.1rem;
  border-radius: 10px;
  border: 1px solid rgba(0, 210, 147, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

.list-txt {
  height: 0.32rem;
  font-size: 0.27rem;
  font-family: Rubik;
  color: rgba(0, 0, 0, 1);
}

.money {
  /* width: 0.43rem; */
  height: 0.43rem;
  font-size: 0.37rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
}

.money-box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.money-img {
  width: 0.27rem;
  height: 0.27rem;
}

.money-num {
  /* width: 0.6rem; */
  height: 0.4rem;
  line-height: 0.4rem;
  font-size: 0.24rem;
  color: rgba(128, 62, 57, 1);
  font-weight: 500;
  font-family: Rubik;
}
.popup {
  font-size: 0.24rem;
  color: #000000;
  font-weight: 500;
  font-family: Rubik;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
